/**
 * Testi italiani di Aiuto, presentazione iniziale, Novità e richieste di aiuto
 * (ADR 0032 §6-8). Le domande frequenti e le novità stanno in `src/content/`,
 * con le due lingue affiancate: sono contenuti, non micro-copy.
 */

/** Testi di aiuto, presentazione e novità. */
export const help = {
  /** Voce del menu. */
  nav: 'Aiuto',
  /** Titolo della pagina. */
  title: 'Aiuto',
  /** Che cosa c'è. */
  description: 'Domande frequenti su institor e un modulo per scrivere agli amministratori.',

  /** Domande frequenti. */
  faq: {
    /** Titolo. */
    title: 'Domande frequenti',
    /** Ricerca. */
    search: 'Cerca nelle domande',
    /** Nessun risultato. */
    empty: 'Nessuna domanda contiene queste parole. Prova con altre o scrivici qui sotto.',
    /** Conteggio dei risultati. */
    results_one: '{{count}} domanda trovata',
    /** Conteggio dei risultati. */
    results_other: '{{count}} domande trovate',
  },

  /** Altre risorse. */
  more: {
    /** Titolo. */
    title: 'Altre risorse',
    /** Rivedere la presentazione. */
    tour: 'Rivedi la presentazione',
    /** Novità. */
    news: 'Novità',
  },

  /** Modulo di contatto. */
  contact: {
    /** Titolo. */
    title: 'Scrivi agli amministratori',
    /** Spiegazione. */
    lead: 'La richiesta arriva agli amministratori di institor, che rispondono appena possono.',
    /** Nome del modulo. */
    form: 'Richiesta di aiuto',
    /** Argomento. */
    category: 'Argomento',
    /** Argomenti. */
    categories: {
      /** Domanda. */
      question: 'Domanda sull’uso',
      /** Problema. */
      problem: 'Qualcosa non funziona',
      /** Abbonamento. */
      billing: 'Abbonamento e pagamenti',
      /** Altro. */
      other: 'Altro',
    },
    /** Oggetto. */
    subject: 'Oggetto',
    /** Oggetto troppo corto. */
    subjectRequired: 'Scrivi un oggetto di almeno 3 caratteri.',
    /** Testo. */
    message: 'Messaggio',
    /** Aiuto sotto il testo. */
    messageExtra: 'Descrivi che cosa hai fatto e che cosa è successo. Non scrivere password o chiavi.',
    /** Testo troppo corto. */
    messageRequired: 'Scrivi almeno 10 caratteri.',
    /** Invio. */
    submit: 'Invia',
    /** Inviata. */
    sent: 'Richiesta inviata. Gli amministratori la leggono appena possono.',
    /** Limite. */
    limit: 'Hai già inviato 5 richieste nelle ultime 24 ore. Riprova più tardi.',
    /** Invio non riuscito. */
    failed: 'Invio non riuscito. Riprova.',
  },

  /** Richieste di aiuto in Amministrazione. */
  requests: {
    /** Scheda. */
    tab: 'Richieste di aiuto',
    /** Titolo. */
    title: 'Richieste di aiuto',
    /** Che cosa sono. */
    description: 'Le richieste scritte dagli utenti dalla pagina Aiuto. Arrivano anche sul canale Telegram degli allarmi.',
    /** Filtro. */
    filter: 'Stato',
    /** Stati. */
    statuses: {
      /** Tutte. */
      all: 'Tutte',
      /** Aperte. */
      open: 'Aperte',
      /** Chiuse. */
      closed: 'Chiuse',
    },
    /** Colonne. */
    columns: {
      /** Data. */
      date: 'Data',
      /** Chi. */
      user: 'Utente',
      /** Argomento. */
      category: 'Argomento',
      /** Oggetto. */
      subject: 'Oggetto',
      /** Stato. */
      status: 'Stato',
    },
    /** Pagina di provenienza. */
    page: 'Scritta da: {{page}}',
    /** Chiudi. */
    close: 'Chiudi',
    /** Chiudi, nome accessibile. */
    closeNamed: 'Chiudi la richiesta «{{subject}}»',
    /** Riapri. */
    reopen: 'Riapri',
    /** Riapri, nome accessibile. */
    reopenNamed: 'Riapri la richiesta «{{subject}}»',
    /** Chiusa. */
    closed: 'Richiesta chiusa.',
    /** Riaperta. */
    reopened: 'Richiesta riaperta.',
    /** Nessuna. */
    empty: 'Nessuna richiesta.',
    /** Lettura non riuscita. */
    loadFailed: 'Richieste non caricate. Riprova.',
  },

  /** Presentazione iniziale. */
  tour: {
    /** Titolo della finestra. */
    title: 'Benvenuto in institor',
    /** Passo n di m. */
    step: 'Passo {{current}} di {{total}}',
    /** Salta. */
    skip: 'Salta',
    /** Indietro. */
    back: 'Indietro',
    /** Avanti. */
    next: 'Avanti',
    /** Fine. */
    done: 'Inizia',
    /** Non mostrare più. */
    dontShow: 'Non mostrare più',
    /** Schermate. */
    slides: {
      /** Il set. */
      sets: {
        /** Titolo. */
        title: 'Un set è una squadra di agenti',
        /** Testo. */
        body: 'Ogni set ha un Institore, gli agenti che lavorano per te e i progetti su cui lavorano. Lo crei da «Nuovo set» e lo trovi nella barra laterale.',
      },
      /** Il relay. */
      relay: {
        /** Titolo. */
        title: 'All’Institore scrivi che cosa serve',
        /** Testo. */
        body: 'L’Institore riceve le tue richieste e dirige gli agenti per tuo conto, come l’institore che gestisce un’impresa per il titolare. A destra vedi chi sta lavorando e su che cosa.',
      },
      /** I task. */
      tasks: {
        /** Titolo. */
        title: 'I task tengono il lavoro in ordine',
        /** Testo. */
        body: 'Gli agenti propongono task e tu li approvi. Il calendario mostra le scadenze di tutti i set.',
      },
      /** La voce. */
      voice: {
        /** Titolo. */
        title: 'Con la voce chiedi a che punto sei',
        /** Testo. */
        body: 'Nella pagina dell’Institore premi «Parla»: l’agente voce racconta lo stato del set e può proporre task. I minuti dipendono dal piano.',
      },
    },
  },

  /** Novità. */
  news: {
    /** Titolo del pannello. */
    title: 'Novità',
    /** Voce del menu utente. */
    menu: 'Novità',
    /** Ci sono novità non lette. */
    unread: 'Ci sono novità da leggere',
    /** Versione. */
    version: 'Versione {{version}}',
  },
};

/** Forma dei testi di aiuto, usata per tipare le altre lingue. */
export type Help = typeof help;
